import React from "react";
import { Link } from "react-router-dom";
import "../App.css";

export default function Logo({ compact = false, className = "" }) {
  return (
    <Link
      to="/"
      data-testid="site-logo"
      aria-label="Viagens Orion"
      className={`inline-flex items-center ${className}`}
    >
      <img
        src="/img/orion-logo.png"
        alt="Viagens Orion"
        loading="eager"
        decoding="async"
        width="180"
        height="48"
        className={compact ? "h-9 w-auto" : "h-11 md:h-12 w-auto"}
        draggable="false"
      />
    </Link>
  );
}
